import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	countLabel: {
		id: 'portal-settings-request-groups.portal-group.count-label.count-label',
		defaultMessage: '{count} {count, plural, one {form} other {forms}}',
		description:
			'Indicates the number of request forms related to a group, for example "1 form", "2 forms"',
	},
});
